import { $authHost } from "./index";

export const fetchAdminPublicPages = async (params = {}) => {
    const { data } = await $authHost.get("api/public-pages/admin/pages", { params });
    return data;
};

export const fetchAdminPublicPage = async (id) => {
    const { data } = await $authHost.get(`api/public-pages/admin/pages/${id}`);
    return data;
};

export const updateAdminPublicPage = async (id, payload) => {
    const { data } = await $authHost.put(`api/public-pages/admin/pages/${id}`, payload);
    return data;
};
